import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { API_ENDPOINT } from '../../../config/config'
import { filterPlayers } from '../../../utils/utils'
import { setTeamUniqPosition } from '../draftConfig/draftConfigSlice'

const initialState = {
	loading: false,
	status: false,
	count: 0,
	pageSize: 6,
	currentPage: 1,
	limit: 700,
	offset: 0,
	results: [],
	poolForRender: null,
	search: '',
	position: ['All'],
	colleage: '',
	iteration: 1,
	playerChoose: [],
	playerManualChoose: [],
	playerIterationChoose: [],
	playerItems: [],
	teamsPlayersData: [],
	allPlayers: [],
	rawTeamBoard: [],
	teamBoards: {},
	teamADP: {},
	globalADP: {},
	// Each team's board as it was when this draft first loaded it ({ playerIds, adpMap }), and the
	// 5-iteration block those boards were last reset for. See resetBoardsForBlock.
	initialTeamBoards: {},
	adpBlock: 1,
}

export const getPlayersDraft = createAsyncThunk(
	'playersDraft/getPlayersDraft',
	async (config, { dispatch, getState, rejectWithValue }) => {
		// console.log('🚀 ~ config:', config)
		try {
			let teamName = config.teamName === '49ers' ? 'ers' : config.teamName
			const res = await axios.get(
				`${API_ENDPOINT}players/?limit=${config.playerCountGet
				}&offset=${0}&search=&position=&school&ordering=-${teamName}`
			)

			const {
				playersDraft: { playerChoose, playerManualChoose, playerIterationChoose },
				draftConfig: {
					fanaticChallenge,
					iterationSection,
					tradeValue,
					countRender,
					fanaticMode,
					teamDraftPlayerChoose,
					infoDraft,
					teamSelect,
					fanaticPlayerBefore,
					round,
					teams,
					teamSelectIndex
				},
			} = getState()
			const resData = { ...res.data }
			let playerReset = []
			let playerManualFlag = false

			// debugger //me
			// Fanatic Choose
			if (fanaticChallenge?.length) {
				const team = tradeValue?.results[countRender]
				let myTeam = team?.round?.id === teamSelect[0].id
				playerReset = iterationSection.iterationSection.includes(countRender) ? [] : playerIterationChoose
				playerManualFlag = playerReset.length > 0 ? false : true
				let playerManualFilter = playerManualChoose

				if (playerManualFlag) {
					playerManualFilter = playerManualChoose.filter(item => !(item.roundTeam < fanaticChallenge[0].mode))

					dispatch(setPlayerIterationChoose([]))
					// dispatch(setPlayerManualChooseNew(playerManualFilter));
					dispatch(setPlayerManualChooseNew([]))
				}
				let playerIteration = []
				if (myTeam) {
					playerIteration = [...playerReset]
				} else {
					if (team.pick === 1 && team.index === 1 && team.round_index_number === '1') {
						playerIteration = []
					} else {
						playerIteration = [...playerReset, ...playerManualFilter]
					}
				}

				const playerChooseId = playerIteration.map(el => el.id)

				let resDataResult = null

				resDataResult = resData.results.filter(player => !playerChooseId.includes(player.id))
				let resDataResultFiltered = resDataResult

				if (team.round_index_number === '1') {
					resDataResult = filterPlayers(
						teamDraftPlayerChoose,
						infoDraft,
						team.round.id,
						+team.round_index_number,
						team.iteration,
						team.pick,
						resDataResultFiltered,
						fanaticPlayerBefore,
						myTeam,
						teamSelectIndex,
						fanaticChallenge
					)
				} 
				if (team.round_index_number === '2' && fanaticChallenge[0].mode === 2) {
					const fanaticPlayerBeforeIds = new Set(fanaticPlayerBefore.map(fp => fp.player.id))
					resDataResult = resDataResult.filter(player => !fanaticPlayerBeforeIds.has(player.id))
					// Client rule: the "same player at most twice" cap applies to every simulated pick,
					// round 2 included. The user's own round-2 pick is governed by the uniqueness
					// filter above instead, so the cap is not applied to their team.
					if (!myTeam) {
						resDataResult = filterPlayers(
							teamDraftPlayerChoose,
							infoDraft,
							team.round.id,
							+team.round_index_number,
							team.iteration,
							team.pick,
							resDataResult,
							fanaticPlayerBefore,
							myTeam,
							teamSelectIndex,
							fanaticChallenge
						)
					}
				}
				// if (fanaticChallenge.length !== 0) {
				// 	if (team.round_index_number === '1' && team.iteration === 4 && team.pick === teams.length) {
				// 		dispatch(setResetTeamsDraftPlayerChoosePlayer());
				// 		dispatch(setResetInfoDraft());
				// 	}
				// }
				// if (resData.results.length === 0) {
				// }
				resData.results = resDataResult.map((item, idx) => {
					return { ...item, bpa: idx + 1 }
				})
			}
			if (fanaticMode) {
				playerReset = iterationSection.iterationSection.includes(countRender) ? [] : playerIterationChoose
				playerManualFlag = playerReset.length > 0 ? false : true
				let playerManualFilter = playerManualChoose

				if (playerManualFlag) {
					dispatch(setPlayerIterationChoose([]))
					dispatch(setPlayerManualChooseNew(playerManualFilter))
					dispatch(setTeamUniqPosition({}))
				}
				let playerIteration = [...playerReset, ...playerManualFilter]
				const playerChooseId = playerIteration.map(el => el.id)
				const resDataResult = resData.results.filter(player => !playerChooseId.includes(player.id))

				resData.results = resDataResult.map((item, idx) => {
					return { ...item, bpa: idx + 1 }
				})
			}

			// Filter Choose Players
			if (playerChoose.length && !fanaticChallenge.length && !fanaticMode) {
				const playerChooseId = playerChoose.map(el => el.id)
				const resDataResult = resData.results.filter(player => !playerChooseId.includes(player.id))
				// if (resData.results.length === 0) {

				// }
				resData.results = resDataResult.map((item, idx) => {
					return { ...item, bpa: idx + 1 }
				})
			} else {
				resData.results = resData.results.map((item, idx) => {
					return { ...item, bpa: idx + 1 }
				})
			}
			// if (resData.results.length === 0) {

			// }
			dispatch(setPlayersDraft(resData))
		} catch (error) {
			if (error.response && error.response.data.message) {
				return rejectWithValue(error.response.data.message)
			} else {
				return rejectWithValue(error.message)
			}
		}
	}
)

export const fetchAllPlayers = createAsyncThunk(
	'playersDraft/fetchAllPlayers',
	async (_, { dispatch, rejectWithValue }) => {
		try {
			const res = await axios.get(
				`${API_ENDPOINT}players/?limit=10000&offset=0&search=&position=&school=`
			)
			dispatch(setAllPlayers(res.data.results))
		} catch (error) {
			if (error.response?.data?.message) return rejectWithValue(error.response.data.message)
			return rejectWithValue(error.message)
		}
	}
)

export const sortPlayersByTeam = createAsyncThunk(
	'playersDraft/sortPlayersByTeam',
	async (config, { dispatch, getState, rejectWithValue }) => {
		try {
			let teamName = config.teamName === '49ers' ? 'ers' : config.teamName

			// Before the state is read below, so the pool for the first pick of a block is built on
			// the reset boards.
			dispatch(resetBoardsForBlock())

			const {
				playersDraft: { allPlayers, teamBoards, playerChoose, playerManualChoose, playerIterationChoose, teamADP, globalADP },
				draftConfig: {
					fanaticChallenge,
					iterationSection,
					tradeValue,
					countRender,
					fanaticMode,
					teamDraftPlayerChoose,
					infoDraft,
					teamSelect,
					fanaticPlayerBefore,
					round,
					teams,
					teamSelectIndex,
				},
			} = getState()

			// Fetch this team's board from TeamBoard API (lazy, cached per team per session)
			let boardPlayerIds = teamBoards[teamName] ?? null
			if (!boardPlayerIds) {
				try {
					const boardRes = await axios.get(`${API_ENDPOINT}team-board/?team=${teamName}`)
					const boardData = Array.isArray(boardRes.data) ? boardRes.data : boardRes.data.results ?? []
					// Order by the board's own rank so array index === board rank (the API
					// response order is not guaranteed to be rank-sorted).
					boardPlayerIds = [...boardData]
						.sort((a, b) => (a.rank ?? a.ranking ?? 999999) - (b.rank ?? b.ranking ?? 999999))
						.map(item => item.player_id)
					dispatch(setTeamBoard({ teamName, playerIds: boardPlayerIds }))
					// Seed the saved ADP so a mock continues where the last one left off (and
					// survives reloads). Only players whose adp diverged from their rank carry a real
					// value; the rest fall back to board rank via sortKey, so we keep teamADP lean.
					const seedADP = {}
					for (const item of boardData) {
						if (item.adp != null && item.adp !== item.rank) seedADP[item.player_id] = item.adp
					}
					if (Object.keys(seedADP).length) dispatch(updateTeamADP({ teamName, adpMap: seedADP }))
					dispatch(snapshotTeamBoard({ teamName, playerIds: boardPlayerIds, adpMap: seedADP }))
				} catch {
					boardPlayerIds = null
				}
			}

			// Build a rank map from the board (player_id → 1-based rank)
			const teamBoardRankMap = boardPlayerIds
				? new Map(boardPlayerIds.map((id, idx) => [id, idx + 1]))
				: null

			const teamADPForTeam = teamADP?.[teamName] ?? {}
			// Sort the whole board on ONE numeric scale — the SAME key the end-of-draft save uses
			// (updateUserTeamBoard): live ADP, else team-board rank, else global ranking. Model B
			// (gradual): an adjusted player only passes a neighbour once its numeric ADP actually
			// crosses him. Do NOT rank every adjusted player ahead of every un-adjusted one — that
			// pushed the untouched #1 (e.g. Jeremiah Smith, ADP 1) behind players with a *worse*
			// ADP (1.75+) and made the card disagree with the saved board.
			const sortKey = p =>
				teamADPForTeam[p.id]
				?? (teamBoardRankMap ? teamBoardRankMap.get(p.id) : undefined)
				?? p.ranking
				?? 999999
			const sortedAll = [...allPlayers].sort((a, b) => sortKey(a) - sortKey(b))

			// For pick 1.1 in FRC mode: build rawTeamBoard from cached team board
			if (fanaticChallenge?.length) {
				const currentPick = tradeValue?.results[countRender]
				if (
					currentPick &&
					+currentPick.round_index_number === 1 &&
					+currentPick.pick === 1 &&
					+currentPick.index === 1
				) {
					const allPlayersById = new Map(allPlayers.map(p => [p.id, p]))
					const teamBoard = boardPlayerIds
						? boardPlayerIds.map(id => allPlayersById.get(id)).filter(Boolean).slice(0, 10)
						: [...allPlayers].sort((a, b) => (a.ranking ?? 999999) - (b.ranking ?? 999999)).slice(0, 10)
					dispatch(setRawTeamBoard(teamBoard))
				}
			}

			// Compute exclusion set before slicing so the pool always has playerCountGet available players
			let excludeIds = new Set()
			let fanaticTeam = null
			let fanaticMyTeam = false
			let fanaticPlayerIteration = []
			let fanaticPlayerManualFilter = playerManualChoose

			if (fanaticChallenge?.length || fanaticMode) {
				fanaticTeam = tradeValue?.results[countRender]
				const playerReset = iterationSection.iterationSection.includes(countRender) ? [] : playerIterationChoose
				const playerManualFlag = playerReset.length === 0

				if (fanaticChallenge?.length && fanaticTeam) {
					fanaticMyTeam = fanaticTeam.round?.id === teamSelect[0].id
					if (playerManualFlag) {
						fanaticPlayerManualFilter = playerManualChoose.filter(item => !(item.roundTeam < fanaticChallenge[0].mode))
						dispatch(setPlayerIterationChoose([]))
						dispatch(setPlayerManualChooseNew([]))
					}
					const isFirstPick = fanaticTeam.pick === 1 && fanaticTeam.index === 1 && fanaticTeam.round_index_number === '1'
					fanaticPlayerIteration = fanaticMyTeam ? [...playerReset]
						: isFirstPick ? []
						: [...playerReset, ...fanaticPlayerManualFilter]
				} else if (fanaticMode) {
					if (playerManualFlag) {
						dispatch(setPlayerIterationChoose([]))
						dispatch(setPlayerManualChooseNew(fanaticPlayerManualFilter))
						dispatch(setTeamUniqPosition({}))
					}
					fanaticPlayerIteration = [...playerReset, ...fanaticPlayerManualFilter]
				}
				fanaticPlayerIteration.forEach(p => excludeIds.add(p.id))
			} else {
				playerChoose.forEach(p => excludeIds.add(p.id))
			}

			// Filter THEN slice — ensures pool always has playerCountGet available players
			const sorted = sortedAll.filter(p => !excludeIds.has(p.id)).slice(0, config.playerCountGet)

			// Additional fanatic-challenge post-slice filtering
			let results = sorted
			if (fanaticChallenge?.length && fanaticTeam) {
				if (fanaticTeam.round_index_number === '1') {
					results = filterPlayers(
						teamDraftPlayerChoose,
						infoDraft,
						fanaticTeam.round.id,
						+fanaticTeam.round_index_number,
						fanaticTeam.iteration,
						fanaticTeam.pick,
						results,
						fanaticPlayerBefore,
						fanaticMyTeam,
						teamSelectIndex,
						fanaticChallenge
					)
				}
				// Rounds after the first: round 2 of the second round challenge, rounds 2 and 3 of the
				// third. Players held for the user's replay slots are off every pool.
				const challengeMode = fanaticChallenge[0].mode
				const pickRound = +fanaticTeam.round_index_number
				if (pickRound >= 2 && pickRound <= challengeMode && (challengeMode === 2 || challengeMode === 3)) {
					const fanaticPlayerBeforeIds = new Set(fanaticPlayerBefore.map(fp => fp.player.id))
					results = results.filter(player => !fanaticPlayerBeforeIds.has(player.id))
					// Third round challenge, user's round 3: never the same player twice over the
					// challenge. The held set above already covers it; this also catches a pick whose
					// replay slot could not be registered.
					if (fanaticMyTeam && challengeMode === 3 && pickRound === 3) {
						const myPicks = teamDraftPlayerChoose.find(t => t.id === fanaticTeam.round.id)?.choosePlayers ?? []
						const priorRound3 = new Set(myPicks.filter(p => p._round === 3).map(p => p.id))
						results = results.filter(player => !priorRound3.has(player.id))
					}
					// Client rule: the "same player at most twice" cap applies to every simulated pick,
					// every round. The user's own picks are governed by the filters above instead, so
					// the cap is not applied to their team.
					if (!fanaticMyTeam) {
						results = filterPlayers(
							teamDraftPlayerChoose,
							infoDraft,
							fanaticTeam.round.id,
							+fanaticTeam.round_index_number,
							fanaticTeam.iteration,
							fanaticTeam.pick,
							results,
							fanaticPlayerBefore,
							fanaticMyTeam,
							teamSelectIndex,
							fanaticChallenge
						)
					}
				}
			}

			const bigBoardRank = new Map(sortedAll.map((p, i) => [p.id, i + 1]))
			const resData = {
				count: allPlayers.length,
				// Stamped with the pick this pool was filtered for — see setPlayersDraft.
				poolForRender: countRender,
				// adp uses the SAME key as the sort (live ADP, else board rank, else ranking) so the
				// ADP and Rank columns never contradict each other; one decimal keeps the running-
				// average value (e.g. 1.75, 11.5) visible.
				results: results.map((item, idx) => ({ ...item, bpa: idx + 1, boardRank: bigBoardRank.get(item.id) ?? item.ranking, adp: Math.round(sortKey(item) * 10) / 10 })),
			}

			dispatch(setPlayersDraft(resData))
		} catch (error) {
			if (error.response?.data?.message) return rejectWithValue(error.response.data.message)
			return rejectWithValue(error.message)
		}
	}
)

// Record ONE pick with the backend, as it happens. The server owns the ADP math: it reads the
// current adp from the DB and applies the rules atomically, so two users drafting the same team
// at once accumulate instead of overwriting each other (the whole-board PATCH lost one of them).
//
// Send no ADP values — anything we send is ignored. `draftedPlayerIds` is every player already
// off the board at this pick, EXCLUDING the player being drafted; the server derives
// availability from that against its own board.
// Re-read a team's board from the server and reseed both the cached order and the ADP map, so
// what's on screen is exactly what the server holds. Replaces (not merges) the ADP so locally
// computed values can't drift, and picks up any concurrent user's picks on the same team.
export const refreshTeamBoard = createAsyncThunk(
	'playersDraft/refreshTeamBoard',
	async ({ teamName }, { dispatch, rejectWithValue }) => {
		try {
			const teamKey = teamName === '49ers' ? 'ers' : teamName
			const res = await axios.get(`${API_ENDPOINT}team-board/?team=${teamKey}`)
			const boardData = Array.isArray(res.data) ? res.data : res.data.results ?? []
			const ordered = [...boardData].sort(
				(a, b) => (a.rank ?? a.ranking ?? 999999) - (b.rank ?? b.ranking ?? 999999)
			)

			dispatch(setTeamBoard({ teamName: teamKey, playerIds: ordered.map(i => i.player_id) }))

			// Only carry players whose adp has diverged from their rank; the rest fall back to
			// board rank, which keeps the map small (same rule as the initial board load).
			const adpMap = {}
			for (const item of ordered) {
				if (item.adp != null && item.adp !== item.rank) adpMap[item.player_id] = item.adp
			}
			dispatch(setTeamADP({ teamName: teamKey, adpMap }))
			dispatch(snapshotTeamBoard({ teamName: teamKey, playerIds: ordered.map(i => i.player_id), adpMap }))
			// Count of players whose adp has diverged from rank = how much ADP this board has
			// accumulated. During the two-browser test this should include the OTHER browser's
			// picks, which is the proof that concurrent drafts are both landing.
			console.log(
				`[BOARD ↻] ${teamKey} | ${ordered.length} players | ${Object.keys(adpMap).length} with adjusted adp |`,
				`top5:`, ordered.slice(0, 5).map(i => `${i.player_name} r${i.rank}/adp${i.adp}`).join(', ')
			)
			return ordered.length
		} catch (error) {
			console.warn('[ADP] refreshTeamBoard failed', error?.response?.data ?? error?.message)
			return rejectWithValue(error?.response?.data ?? error?.message)
		}
	}
)

export const recordDraftPick = createAsyncThunk(
	'playersDraft/recordDraftPick',
	async ({ teamName, playerId, selection, draftedPlayerIds = [] }, { dispatch, rejectWithValue }) => {
		const teamKey = teamName === '49ers' ? 'ers' : teamName
		const payload = {
			player_id: playerId,
			selection,
			drafted_player_ids: draftedPlayerIds,
		}
		console.log(
			`[PICK →] ${teamKey} sel ${selection} player ${playerId} | drafted ${draftedPlayerIds.length}`,
			JSON.stringify(payload)
		)
		try {
			const res = await axios.post(`${API_ENDPOINT}team-board/pick/?team=${teamKey}`, payload)
			const d = res.data ?? {}
			console.log(
				`[PICK ←] ${teamKey} player ${d.player_id ?? playerId} | ` +
				`adp ${d.previous_adp} → ${d.adp} | shifted ${d.shifted} | ranks_updated ${d.ranks_updated}`,
				d
			)
			// The POST response only carries the picked player's new adp, not the shifted players',
			// so re-read the board to get the server's exact state for everyone.
			await dispatch(refreshTeamBoard({ teamName: teamKey }))
			return res.data
		} catch (error) {
			// A failed pick post must never block the draft — log and move on.
			console.warn('[PICK ✗] recordDraftPick failed', error?.response?.data ?? error?.message)
			return rejectWithValue(error?.response?.data ?? error?.message)
		}
	}
)

// Legacy: PATCHes the full re-ranked board to team-board/update/. Still used for manual
// re-ranking in the UI, but NOT at the end of a mock draft — that overwrites the ADP the
// backend accumulated per pick.
export const updateUserTeamBoard = createAsyncThunk(
	'playersDraft/updateUserTeamBoard',
	async (_, { dispatch, getState, rejectWithValue }) => {
		try {
			const {
				playersDraft: { teamBoards, teamADP },
				draftConfig: { teamSelect },
			} = getState()

			const userTeamName = teamSelect?.[0]?.name
			if (!userTeamName) return null
			const teamKey = userTeamName === '49ers' ? 'ers' : userTeamName

			const boardIds = teamBoards?.[teamKey]
			if (!boardIds?.length) return null

			// Re-rank the board by ADP. Per spec item 5, a player's initial ADP == their rank,
			// so a player with NO adjustment keeps his original board rank as his ADP (rather
			// than being pushed below every adjusted player). Sort everyone by effective ADP.
			const adpForTeam = teamADP?.[teamKey] ?? {}
			const origRank = new Map(boardIds.map((id, idx) => [id, idx + 1]))
			const effAdp = id => adpForTeam[id] ?? origRank.get(id)
			const reordered = [...boardIds].sort((a, b) => effAdp(a) - effAdp(b))

			// Save BOTH: rank = integer position (display/order), adp = the fractional running-
			// average value so the next mock continues from here instead of resetting to integer
			// ranks. Round to 4 dp to avoid float noise; unadjusted players save adp == rank.
			const body = reordered.map((id, idx) => ({
				player_id: id,
				rank: idx + 1,
				adp: Math.round(effAdp(id) * 10000) / 10000,
			}))

			// TEMP diagnostics
			const adpCount = Object.keys(adpForTeam).length
			const changed = reordered.filter((id, idx) => id !== boardIds[idx]).length
			console.log('[TEAM-BOARD PATCH]', teamKey,
				'| board size:', boardIds.length,
				'| players with adjusted ADP:', adpCount,
				'| positions changed:', changed)
			console.log('[TEAM-BOARD PATCH] teamADP for team:', adpForTeam)
			console.log('[TEAM-BOARD PATCH] first 12 original:', boardIds.slice(0, 12))
			console.log('[TEAM-BOARD PATCH] first 12 reordered:', reordered.slice(0, 12))

			const res = await axios.patch(`${API_ENDPOINT}team-board/update/?team=${teamKey}`, body)

			// Update the local cached board so the very next draft in this session starts from
			// the new order (otherwise it keeps using the stale original board until a reload).
			//
			// Do NOT clear the team's ADP: the running-average model needs the fractional values
			// to carry across drafts, otherwise every player restarts from its integer board rank
			// and can never converge past a neighbour (e.g. a pick at slot 1 forever oscillates at
			// 1.25 and never crosses the #1 player). Keeping teamADP lets 1.25 → 0.875 → … so the
			// skipped top player falls over the 2–4 drafts the client expects.
			dispatch(setTeamBoard({ teamName: teamKey, playerIds: reordered }))

			return res.data
		} catch (error) {
			if (error.response?.data?.message) return rejectWithValue(error.response.data.message)
			return rejectWithValue(error.message)
		}
	}
)

export const searchPlayersDraft = createAsyncThunk(
	'playersDraft/searchPlayersDraft',
	async (search, { dispatch, getState, rejectWithValue }) => {
		try {
			const {
				playersDraft: { position, colleage },
			} = getState()
			const res = await axios.get(
				`${API_ENDPOINT}players/?limit=${18}&offset=${0}&search=${search}&position=${position}&school=${colleage}`
			)
			const resData = { ...res.data, search }
			dispatch(setPlayersDraft(resData))
		} catch (error) {
			if (error.response && error.response.data.message) {
				return rejectWithValue(error.response.data.message)
			} else {
				return rejectWithValue(error.message)
			}
		}
	}
)

export const postitionPlayersDraft = createAsyncThunk(
	'playersDraft/postitionPlayersDraft',
	async (position, { dispatch, getState, rejectWithValue }) => {
		try {
			const {
				players: { colleage, limit },
			} = getState()

			const res = await axios.get(
				`${API_ENDPOINT}players/?limit=${limit}&offset=${0}&search=&position=${position}&school=${colleage}`
			)
			const resData = { ...initialState, ...res.data, limit, position }

			dispatch(setPlayersDraft(resData))
		} catch (error) {
			if (error.response && error.response.data.message) {
				return rejectWithValue(error.response.data.message)
			} else {
				return rejectWithValue(error.message)
			}
		}
	}
)

export const colleagePlayersDraft = createAsyncThunk(
	'playersDraft/colleagePlayersDraft',
	async (colleage, { dispatch, getState, rejectWithValue }) => {
		try {
			const {
				playersDraft: { position },
			} = getState()
			const res = await axios.get(
				`${API_ENDPOINT}players/?limit=${18}&offset=${0}&search=&position=${position}&school=${colleage}`
			)
			const resData = { ...initialState, ...res.data, colleage }
			dispatch(setPlayersDraft(resData))
		} catch (error) {
			if (error.response && error.response.data.message) {
				return rejectWithValue(error.response.data.message)
			} else {
				return rejectWithValue(error.message)
			}
		}
	}
)

export const playersDraftSlice = createSlice({
	name: 'playersDraft',
	initialState,
	reducers: {
		setPlayersDraft: (state, action) => {
			state.limit = action.payload?.limit || state.limit
			state.offset = action.payload?.offset || state.offset
			state.currentPage = action.payload?.currentPage || state.currentPage
			state.search = action.payload?.search || state.search
			state.position = action.payload?.position || state.position
			state.colleage = action.payload?.colleage || state.colleage
			state.count = action.payload.count
			state.next = action.payload.next
			state.previous = action.payload.previous
			state.results = action.payload.results
			// Which pick this pool was built for. The auto-pick engine waits for a pool stamped with
			// the pick it is about to make, instead of trusting a "sort pending" flag that any other
			// results update could clear.
			if (action.payload.poolForRender !== undefined) state.poolForRender = action.payload.poolForRender
			state.status = true
		},
		setSearchPlayers: (state, action) => {
			state.search = action.payload
		},
		setPositionPlayersDraft: (state, action) => {
			state.position = action.payload
		},
		setColleagePlayers: (state, action) => {
			state.colleage = action.payload
		},
		setCurrentPage: (state, action) => {
			state.currentPage = action.payload
		},
		setPlayerItems: (state, action) => {
			state.playerItems = action.payload
		},
		setNewPlayers: (state, action) => {
			state.results = action.payload
			state.limit = action.payload.length
		},
		setTeamsPlayersData: (state, action) => {
			state.teamsPlayersData = action.payload
		},
		setAllPlayers: (state, action) => {
			state.allPlayers = action.payload
		},
		setRawTeamBoard: (state, action) => {
			state.rawTeamBoard = action.payload
		},
		setTeamBoard: (state, action) => {
			const { teamName, playerIds } = action.payload
			state.teamBoards[teamName] = playerIds
		},
		updateTeamADP: (state, action) => {
			const { teamName, adpMap } = action.payload
			state.teamADP[teamName] = { ...(state.teamADP[teamName] ?? {}), ...adpMap }
		},
		// REPLACES a team's ADP map (unlike updateTeamADP which merges). Used when reseeding from
		// the server after a pick, so locally-computed values can't linger once the authoritative
		// board comes back.
		setTeamADP: (state, action) => {
			const { teamName, adpMap } = action.payload
			state.teamADP[teamName] = adpMap ?? {}
		},
		clearTeamADP: (state, action) => {
			// After a team's board is re-ranked and persisted, its new ranks are the baseline,
			// so clear the transient ADP shifts for that team.
			state.teamADP[action.payload] = {}
		},
		updateGlobalADP: (state, action) => {
			state.globalADP = { ...state.globalADP, ...action.payload }
		},
		// Keeps the first board this draft loaded for a team; later loads and refreshes are ignored,
		// so the baseline is always the board before any pick of this draft touched it.
		snapshotTeamBoard: (state, action) => {
			const { teamName, playerIds, adpMap } = action.payload
			if (state.initialTeamBoards[teamName]) return
			state.initialTeamBoards[teamName] = { playerIds: [...playerIds], adpMap: { ...(adpMap ?? {}) } }
		},
		restoreTeamBoards: (state, action) => {
			const { exclude, block } = action.payload
			for (const [teamName, initial] of Object.entries(state.initialTeamBoards)) {
				if (exclude.includes(teamName)) continue
				state.teamBoards[teamName] = [...initial.playerIds]
				state.teamADP[teamName] = { ...initial.adpMap }
			}
			state.adpBlock = block
		},
		setPlayerChoose: (state, action) => {
			state.playerChoose = action.payload
		},
		setPlayerManualChoose: (state, action) => {
			state.playerManualChoose.push(action.payload)
		},
		setPlayerManualChooseNew: (state, action) => {
			state.playerManualChoose = action.payload
		},
		setIteration: (state, action) => {
			state.iteration = action.payload
		},
		setPlayerIterationChoose: (state, action) => {
			state.playerIterationChoose = action.payload
		},
		resPlayersDraft: (state, action) => {
			// state = initialState
			state.loading = initialState.loading
			state.status = initialState.status
			state.colleage = initialState.colleage
			state.count = initialState.count
			state.currentPage = initialState.currentPage
			state.limit = initialState.limit
			state.offset = initialState.offset
			state.pageSize = initialState.pageSize
			state.playerChoose = initialState.playerChoose
			state.playerManualChoose = initialState.playerManualChoose
			state.playerIterationChoose = initialState.playerIterationChoose
			state.playerItems = initialState.playerItems
			state.position = initialState.position
			state.results = initialState.results
			state.search = initialState.search
			state.teamsPlayersData = initialState.teamsPlayersData
			state.position = initialState.position
			state.colleage = initialState.colleage
			state.iteration = initialState.iteration
			state.allPlayers = initialState.allPlayers
			state.rawTeamBoard = initialState.rawTeamBoard
			state.teamBoards = initialState.teamBoards
			state.teamADP = initialState.teamADP
			state.globalADP = initialState.globalADP
			state.initialTeamBoards = initialState.initialTeamBoards
			state.adpBlock = initialState.adpBlock
		},
	},
	extraReducers: {
		[getPlayersDraft.fulfilled]: (state, action) => {
			state.loading = false
		},
		[getPlayersDraft.pending]: (state, action) => {
			state.loading = true
		},
		[getPlayersDraft.rejected]: (state, action) => {
			state.loading = false
		},
		[searchPlayersDraft.fulfilled]: (state, action) => {
			state.loading = false
		},
		[searchPlayersDraft.pending]: (state, action) => {
			state.loading = true
		},
		[searchPlayersDraft.rejected]: (state, action) => {
			state.loading = false
		},
		[postitionPlayersDraft.fulfilled]: (state, action) => {
			state.loading = false
		},
		[postitionPlayersDraft.pending]: (state, action) => {
			state.loading = true
		},
		[postitionPlayersDraft.rejected]: (state, action) => {
			state.loading = false
		},
		[colleagePlayersDraft.fulfilled]: (state, action) => {
			state.loading = false
		},
		[colleagePlayersDraft.pending]: (state, action) => {
			state.loading = true
		},
		[colleagePlayersDraft.rejected]: (state, action) => {
			state.loading = false
		},
		[fetchAllPlayers.pending]: (state) => {
			state.loading = true
		},
		[fetchAllPlayers.fulfilled]: (state) => {
			state.loading = false
		},
		[fetchAllPlayers.rejected]: (state) => {
			state.loading = false
		},
		[sortPlayersByTeam.pending]: (state) => {
			state.loading = true
		},
		[sortPlayersByTeam.fulfilled]: (state) => {
			state.loading = false
		},
		[sortPlayersByTeam.rejected]: (state) => {
			state.loading = false
		},
	},
})

export const selectPlayersDraft = state => state.playersDraft

export const {
	setPlayersDraft,
	setSearchPlayers,
	setPositionPlayersDraft,
	setColleagePlayers,
	setCurrentPage,
	setPlayerItems,
	setNewPlayers,
	resPlayersDraft,
	setPlayerChoose,
	setPlayerManualChoose,
	setIteration,
	setPlayerIterationChoose,
	setPlayerManualChooseNew,
	setAllPlayers,
	setRawTeamBoard,
	setTeamBoard,
	updateTeamADP,
	setTeamADP,
	clearTeamADP,
	updateGlobalADP,
	snapshotTeamBoard,
	restoreTeamBoards,
} = playersDraftSlice.actions

// Same block as the "max 2 per team" cap in filterPlayers (utils.js ITERATION_BLOCK).
const BOARD_RESET_BLOCK = 5

// Second and third round challenges: iterations 6-10 replay 1-5 from the same starting boards (client: the
// player taken at 1.1 in iteration 1 should be taken at 1.1 in iteration 6). The cap already
// resets per block in filterPlayers, but every simulated pick also moves that team's ADP, and
// those moves carried over — in a test run the 1.1 team took Smith, Moore, Stewart, Goosby,
// Manning in 1-5 and the same five in another order in 6-10. So at the first pick of a new block,
// each simulated team's board and ADP go back to what this draft first loaded. The user's own
// team is left alone: its board is the shared server board, which their picks really did move.
export const resetBoardsForBlock = () => (dispatch, getState) => {
	const {
		playersDraft: { adpBlock, initialTeamBoards },
		draftConfig: { fanaticChallenge, fanaticMode, tradeValue, countRender, teamSelect },
	} = getState()
	const mode = fanaticChallenge?.[0]?.mode
	if (fanaticMode || (mode !== 2 && mode !== 3)) return
	const iteration = +tradeValue?.results?.[countRender]?.iteration || 1
	const block = Math.ceil(iteration / BOARD_RESET_BLOCK)
	if (block <= adpBlock) return
	const userTeams = (teamSelect ?? []).map(t => (t.name === '49ers' ? 'ers' : t.name))
	const resetTeams = Object.keys(initialTeamBoards).filter(name => !userTeams.includes(name))
	dispatch(restoreTeamBoards({ exclude: userTeams, block }))
	console.log(
		`[${mode === 3 ? 'TRC' : 'SRC'}] iter ${iteration}: block ${block} starts — ${resetTeams.length} simulated boards reset to their start-of-draft ADP`,
		`(user team kept: ${userTeams.join(', ')})`
	)
}

// Action Creator Thunk
export const positionAction = positionValue => (dispatch, getState) => {
	const {
		playersDraft: { limit },
	} = getState()
	if (positionValue === '') {
		dispatch(setPositionPlayersDraft(''))
		dispatch(getPlayersDraft(limit))
	} else {
		dispatch(postitionPlayersDraft(positionValue))
	}
}

// export const playerPositionMulti = pos => (dispatch, getState) => {
// 	const {
// 		playersDraft: { position },
// 	} = getState()
// 	let newPosition = []
//
// 	if (position.length && position.includes(pos) && pos !== 'All') {
// 		newPosition = position.filter(item => item !== pos)
// 	} else if (pos === 'All') {
// 		newPosition = [pos]
// 	} else {
// 		if (position.includes('All')) {
// 			const exceptAll = position.filter(item => item !== 'All')
// 			newPosition = [...exceptAll, pos]
// 		} else {
// 			newPosition = [...position, pos]
// 		}
// 	}
// 	if (!newPosition.length) {
// 		newPosition = ['All']
// 	}
// 	dispatch(setPositionPlayersDraft(newPosition))
// }



//today 15.09
export const playerPositionMulti = pos => (dispatch, getState) => {
	const {
		playersDraft: { position },
	} = getState()
	let newPosition = []
	const isIOL = pos === 'iOL'
	const iOLGroup = ['iOL', 'iOL_C']
	if (position.length && position.includes(pos) && pos !== 'All') {
		if (isIOL) {
			newPosition = position.filter(item => !iOLGroup.includes(item))
		} else {
			newPosition = position.filter(item => item !== pos)
		}
	} else if (pos === 'All') {
		newPosition = ['All']
	} else {
		if (position.includes('All')) {
			const exceptAll = position.filter(item => item !== 'All')
			newPosition = isIOL ? [...exceptAll, ...iOLGroup] : [...exceptAll, pos]
		} else {
			newPosition = isIOL ? [...position, ...iOLGroup] : [...position, pos]
		}
	}
	if (!newPosition.length) {
		newPosition = ['All']
	}
	newPosition = [...new Set(newPosition)] //check
	dispatch(setPositionPlayersDraft(newPosition))
}



export const colleageAction = colleageValue => (dispatch, getState) => {
	if (colleageValue === '') {
		dispatch(setColleagePlayers(''))
		dispatch(getPlayersDraft())
	} else {
		dispatch(colleagePlayersDraft(colleageValue))
	}
}

export const delPlayersDraft =
	(players, iter = 1) =>
		(dispatch, getState) => {
			const {
				playersDraft: { results, playerChoose, playerIterationChoose },
			} = getState()

			// const delPlayers = [...players,...playerChoose]

			dispatch(setPlayerChoose([...players, ...playerChoose]))
			const playersId = players.map(player => player.id)
			const playerData = results.filter(item => !playersId.includes(item.id))

			// if (iter !== iteration) {

			//   dispatch(setIteration(iter))
			//   dispatch(setPlayerIterationChoose([...players]));
			// } else {
			dispatch(setPlayerIterationChoose([...players, ...playerIterationChoose]))
			// }
			dispatch(setNewPlayers(playerData))
		}

export default playersDraftSlice.reducer
